// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__2N-SD","link":"dashboard_link__3QGhN"};